import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { isMobileDevice } from './device.util';

@Injectable({ providedIn: 'root' })
export class DevtoolsService {

  // Layer 1: window size difference — catches docked DevTools
  private isOpenBySize(): boolean {
    return (
      window.outerWidth - window.innerWidth > 160 ||
      window.outerHeight - window.innerHeight > 160
    );
  }

  // Layer 2: console object trick — catches undocked DevTools (separate window)
  private isOpenByConsole(): boolean {
    let opened = false;
    const el = document.createElement('div');
    Object.defineProperty(el, 'id', {
      get: () => {
        opened = true;
        return '';
      }
    });
    // eslint-disable-next-line no-console
    console.log('%c', el);
    // eslint-disable-next-line no-console
    console.clear();
    return opened;
  }

  isDevToolsOpen(): boolean {
    if (!environment.securityEnabled) return false;
    if (isMobileDevice()) return false;
    return this.isOpenBySize() || this.isOpenByConsole();
  }

  // Runs checks during browser idle time only, pauses when tab is hidden.
  startMonitoring(onOpen: () => void): void {
    if (!environment.securityEnabled) return;
    if (isMobileDevice()) return;

    const schedule = () => {
      const idleCallback = (window as any).requestIdleCallback ?? window.setTimeout;
      idleCallback(
        () => {
          if (document.visibilityState === 'visible' && this.isDevToolsOpen()) {
            onOpen();
          } else {
            schedule();
          }
        },
        { timeout: 2000 }
      );
    };

    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') schedule();
    });

    schedule();
  }
}
